/**
 * Zod-Schema für Abwesenheits-Anträge.
 */
import { z } from 'zod';
import { ABSENCE_TYPES } from '../enums/index.js';

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Datum im Format YYYY-MM-DD');

export const createAbsenceSchema = z
  .object({
    type: z.enum(ABSENCE_TYPES),
    startDate: isoDate,
    endDate: isoDate,
    reason: z.string().trim().max(2000).optional(),
  })
  .refine((v) => v.endDate >= v.startDate, {
    message: 'Ende darf nicht vor dem Start liegen',
    path: ['endDate'],
  });
export type CreateAbsenceInput = z.infer<typeof createAbsenceSchema>;
